import React, { useEffect, useState, useRef } from "react";

import { useToast } from "../../components/ui";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../components";
import { Header } from "../../components/modules";

import { FiFileText } from "react-icons/fi";
import Context from "../../Context";

import { MdPersonSearch } from "react-icons/md";
import { Spinner } from "reactstrap";
import constant, { statuses } from "../../constants";
import { CSVLink } from "react-csv";
import { thaiDate } from "../../util";

import th from "antd/es/date-picker/locale/th_TH";
import dayTh from "dayjs/locale/th";
import dayjs from "dayjs";
import buddhistEra from "dayjs/plugin/buddhistEra";

dayjs.extend(buddhistEra);
dayjs.locale(dayTh);

const buddhistLocale = {
  ...th,
  lang: {
    ...th.lang,
    fieldDateFormat: "DD-MM-BBBB",
    fieldDateTimeFormat: "DD-MM-BBBB HH:mm:ss",
    yearFormat: "BBBB",
    cellYearFormat: "BBBB",
  },
};

export const ReportNetIncome = () => {
  const downloadRef = useRef(null);
  const { toast } = useToast();
  const { callApi, configs } = Context();
  const [orders, setOrders] = useState(false);
  const [selectedRoundDate, setSelectedRoundDate] = useState(configs.roundDate);
  const [summary, setSummary] = useState(false);

  const [loading, setLoading] = useState(false);

  const [csvFileName, setCsvFileName] = useState("");
  const [csvData, setCsvData] = useState([]);
  const [downloaded, setDownloaded] = useState([]);

  useEffect(() => {
    if (csvFileName && !downloaded.includes(csvFileName)) {
      downloadRef.current.childNodes[0].click();
      setDownloaded((old) => [...old, csvFileName]);
    }
  }, [csvFileName]);

  const getOrders = async () => {
    setLoading(true);

    const allUserData = [];
    let keepGoing = true;
    let currentIndex = 0;
    let startAtId = "";
    let limit = 5000;

    while (keepGoing) {
      console.log(`calling index ${currentIndex}-${currentIndex + limit}`);
      const data = await callApi(
        "orders-getAll",
        {
          queries: [
            ["status", statuses.APPROVE],
            ["deliverChannel", "online"],
          ],
          limit,
          startAfter: startAtId,
          roundDate: selectedRoundDate,
          orderBy: ["createdAt", "desc"],
        },
        { notShowLoading: true }
      );

      if (data.length < limit || !data.length || !data) {
        console.log("stop");
        keepGoing = false;
        setLoading(false);
      } else {
        console.log(`fetching size: ${data.length}`);
        console.log("id", data[data.length - 1].id);
        startAtId = data[data.length - 1].id;
      }
      allUserData.push(...data);
      console.log(`allUserData size: ${allUserData.length}`);
      currentIndex += limit;
    }

    setLoading(false);
    setOrders(allUserData.sort((a, b) => b.createdAt - a.createdAt));

    const summary = allUserData.reduce(
      (acc, order) => {
        acc.totalBase += 80 * order.size;
        acc.totalFee += order.totalPrice - 80 * order.size;
        acc.totalPrice += Number(order.totalPrice);
        acc.lottoCount += order.size;
        return acc;
      },
      {
        totalBase: 0,
        totalFee: 0,
        totalPrice: 0,
        lottoCount: 0,
      }
    );

    setSummary(summary);
  };

  const handleDownload = async () => {
    const csvData = [
      [`รายงานค่าเช่าพื้นที่ฝากและบริการ_${thaiDate()}`],
      [""],
      [
        "คำสั่งซื้อทั้งหมด",
        "จำนวนสลากทั้งหมด",
        "ค่าสลากทั้งหมด",
        "ค่าเช่าพื้นที่ฝากพร้อมบริการ",
        "รายได้รวมทั้งหมด",
      ],
      [
        orders.length,
        summary.lottoCount,
        summary.totalBase,
        summary.totalFee,
        summary.totalPrice,
      ],
      [""],
      [
        "ลำดับ",
        "วัน-เวลา",
        "รหัสคำสั่งซื้อ",
        "รหัสผู้ใช้",
        "ชื่อ-นามสกุล",
        "เบอร์โทรศัพท์",
        "จำนวนใบ",
        "ราคาสลาก",
        "ค่าเช่าพื้นที่ฝากพร้อมบริการ",
        "ราคารวม",
        "สถานะ",
      ],
    ];
    orders.forEach((order, index) => {
      const base = 80 * order.size;
      const fee = order.totalPrice - 80 * order.size;
      return csvData.push([
        index + 1,
        new Date(order.createdAt).toLocaleDateString("th-TH", {
          year: "numeric",
          month: "numeric",
          day: "numeric",
          hour: "numeric",
          minute: "numeric",
        }),

        order.shortId,
        order.userId,
        order.firstName + " " + order.lastName,
        order.phone,
        order.size,
        base,
        fee,
        order.totalPrice,
        order.status,
      ]);
    });

    setCsvData(csvData);
    setCsvFileName(`รายงานค่าเช่าพื้นที่ฝากและบริการ_งวด_${thaiDate()}.csv`);
  };

  return (
    <div className="h-fit w-full max-w-[1600px] mb-24">
      {/* header */}
      <Header
        header="Report"
        subHeader="รายงานค่าเช่าพื้นที่ฝากและบริการ"
        icon={<FiFileText className="text-blue" />}
      />

      <div className="relative w-96 bg-white rounded-lg shadow-md mt-4 border border-gray-300 overflow-hidden">
        <div className="p-3 border-b border-gray-300">
          <p className="font-semibold ">ค้นหาคำสั่งซื้อสลาก</p>
        </div>
        <div className="relative grid grid-cols-2 items-center gap-3 p-3 ">
          {loading && (
            <div className="z-50 bg-[rgb(255,255,255,0.7)] absolute h-full w-full flex justify-center items-center">
              <Spinner className="w-4 h-4 " />
            </div>
          )}
          <div className="gap-2 col-span-2">
            <p className="font-medium text-xs">งวด</p>
            <div>
              <select
                className="border-2 w-full h-9 border-gray-300 rounded-lg cursor-pointer disabled:cursor-not-allowed disabled:opacity-65"
                value={selectedRoundDate}
                onChange={(e) => setSelectedRoundDate(e.target.value)}
              >
                {configs.roundDates.map((roundDate) => (
                  <option key={roundDate} value={roundDate}>
                    {roundDate}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <button
            disabled={loading}
            className="flex items-center justify-center gap-1 py-2 px-3 bg-blue text-white text-sm font-semibold rounded-lg shadow-md hover:opacity-60 transition-all duration-200 disabled:opacity-60"
            onClick={() => {
              getOrders();
            }}
          >
            <MdPersonSearch className="text-white" />
            ค้นหา
          </button>
          <button
            disabled={!orders.length}
            className="flex items-center justify-center gap-1 py-2 px-3 bg-[rgb(59,176,101)] text-white text-sm font-semibold rounded-lg shadow-md hover:opacity-60 transition-all duration-200 disabled:bg-slate-300 disabled:hover:opacity-100 disabled:cursor-not-allowed"
            onClick={() => {
              handleDownload();
            }}
          >
            ดาวโหลด
          </button>
        </div>
      </div>
      <div ref={downloadRef}>
        <CSVLink
          data={csvData}
          filename={csvFileName}
          style={{ display: "none" }}
        >
          Download me
        </CSVLink>
      </div>
      {summary && (
        <div className="relative bg-white w-full rounded-lg shadow-md mt-4 border border-gray-300 overflow-hidden">
          <div className="flex bg-white gap-3 items-center p-3 border-b border-gray-300">
            <p className="font-semibold ">
              สรุปรายได้ค่าเช่าพื้นที่ฝากและบริการ งวด {selectedRoundDate}
            </p>{" "}
          </div>
          <Table>
            <TableHeader className={`bg-[#f2f3f5]`}>
              <TableRow>
                <TableHead className="text-center">คำสั่งซื้อทั้งหมด</TableHead>
                <TableHead className="text-center">จำนวนสลากทั้งหมด</TableHead>
                <TableHead className="text-center">ค่าสลากทั้งหมด</TableHead>
                <TableHead className="text-center">
                  ค่าเช่าพื้นที่ฝากพร้อมบริการ
                </TableHead>
                <TableHead className="text-center">รายได้รวมทั้งหมด</TableHead>
              </TableRow>
            </TableHeader>

            <TableBody className={``}>
              {orders.length > 0 ? (
                <TableRow>
                  <TableCell className={`text-center font-semibold`}>
                    {orders.length.toLocaleString() || 0}
                  </TableCell>
                  <TableCell className={`text-center font-semibold`}>
                    {summary.lottoCount.toLocaleString() || 0}
                  </TableCell>
                  <TableCell className={`text-center font-semibold`}>
                    {summary.totalBase.toLocaleString() || 0}
                  </TableCell>
                  <TableCell className={`text-center font-semibold`}>
                    {summary.totalFee.toLocaleString() || 0}
                  </TableCell>
                  <TableCell className={`text-center font-semibold`}>
                    {summary.totalPrice.toLocaleString() || 0}
                  </TableCell>
                </TableRow>
              ) : (
                <TableRow>
                  <TableCell className="" colSpan="8">
                    <div className="min-h-52 w-full flex justify-center items-center font-medium text-[#969797]">
                      <div>
                        <MdPersonSearch className="text-white" />
                        ไม่พบคำสั่งซื้อ
                      </div>
                    </div>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </div>
      )}
      {orders && (
        <div className="relative bg-white w-full rounded-lg shadow-md mt-4 border border-gray-300 overflow-hidden">
          <div className="flex bg-white gap-3 items-center p-3 border-b border-gray-300">
            <p className="font-semibold ">คำสั่งซื้อทั้งหมด</p>{" "}
            <p className="text-xs font-semibold text-[#969797]">
              {orders.length} คำสั่งซื้อ
            </p>
          </div>
          <Table>
            <TableHeader className={`bg-[#f2f3f5]`}>
              <TableRow>
                <TableHead className="">วันที่-เวลา</TableHead>
                <TableHead className="">รหัสคำสั่งซื้อ</TableHead>
                <TableHead className="">ช่องทางการซื้อ</TableHead>
                <TableHead className={"text-right"}>รหัสผู้ใช้</TableHead>
                <TableHead>ชื่อ-นามสกุล</TableHead>

                <TableHead>เบอร์โทรศัพท์</TableHead>
                <TableHead className={"text-center"}>จำนวนสลาก</TableHead>
                <TableHead className={"text-right"}>ราคาสลาก</TableHead>
                <TableHead className={"text-right"}>
                  ค่าเช่าพื้นที่ฝากพร้อมบริการ
                </TableHead>
                <TableHead className={"text-right"}>ราคารวม</TableHead>
                <TableHead className={"text-right"}>สถานะ</TableHead>
              </TableRow>
            </TableHeader>

            <TableBody className={``}>
              {orders.length > 0 ? (
                orders.map((order) => {
                  const base = 80 * order.size;
                  const fee = order.totalPrice - 80 * order.size;
                  return (
                    <TableRow key={order.shortId}>
                      <TableCell className={`font-medium`}>
                        {new Date(order.createdAt).toLocaleDateString("th-TH", {
                          year: "numeric",
                          month: "numeric",
                          day: "numeric",
                          hour: "numeric",
                          minute: "numeric",
                        })}{" "}
                        น.
                      </TableCell>
                      <TableCell className="font-semibold font-mono tabular-nums text-center">
                        {order.shortId}
                      </TableCell>
                      <TableCell>
                        {order.deliverChannel === "online"
                          ? "1. เช่าพื้นที่พร้อมบริการฯ"
                          : order.deliverChannel === "offline"
                          ? "2. ส่งไปรษณีย์"
                          : "3. มารับเอง 80 บาท"}
                      </TableCell>
                      <TableCell
                        className={`font-semibold text-right font-mono tabular-nums`}
                      >
                        {order.userId}
                      </TableCell>
                      <TableCell className="font-medium">
                        {order.firstName + " " + order.lastName}
                      </TableCell>
                      <TableCell className="font-medium">
                        {order.phone}
                      </TableCell>
                      <TableCell className="text-center font-mono tabular-nums">
                        {order.size}
                      </TableCell>
                      <TableCell className="font-semibold text-right font-mono tabular-nums">
                        {base.toLocaleString()}
                      </TableCell>
                      <TableCell className="font-semibold text-right font-mono tabular-nums">
                        {fee.toLocaleString()}
                      </TableCell>
                      <TableCell className="font-semibold text-right font-mono tabular-nums">
                        {order.totalPrice.toLocaleString()}
                      </TableCell>
                      <TableCell className="">
                        <p
                          className={`${
                            order.status === statuses.APPROVE
                              ? "text-[rgb(59,176,101)]"
                              : order.status === statuses.PAID
                              ? "text-[#4DA1A9]"
                              : order.status === statuses.PENDING
                              ? "text-[#FAB12F]"
                              : "text-[#c15b78]"
                          } text-right font-semibold`}
                        >
                          {constant.statusesTranslate[order.status]}
                        </p>
                      </TableCell>
                    </TableRow>
                  );
                })
              ) : (
                <TableRow>
                  <TableCell className="" colSpan="8">
                    <div className="min-h-52 w-full flex justify-center items-center font-medium text-[#969797]">
                      <div>
                        <MdPersonSearch className="text-white" />
                        ไม่พบคำสั่งซื้อ
                      </div>
                    </div>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </div>
      )}
    </div>
  );
};
